export default __webpack_public_path__ + "static/media/player-progress-slider.f7acffc8.svg";